// extracted by mini-css-extract-plugin
export default {"device":"index_device__rTydO","box":"index_box__fJmxb"};